import React from 'react';
import { Props } from './Header.types';
import styles from './Header.module.scss';
import { Button } from 'modules/af_cm_ui_kit/components';
import { useHistory } from 'react-router-dom';
import { caseManagement } from 'routes/routePaths';
import { useSelector } from 'react-redux';
import { State } from 'modules/cm/store/cases/types';
import Separator from '../../../../components/Separator/Separator';
import Banner from '../../../../components/Banner/Banner';
import { Nullable } from 'utils/types';
import { DueDiligenceStatus } from 'modules/cm/domain/DueDiligence/DueDiligence';
import { Icon } from 'lmc-ui-library';
import { format } from 'utils/date';
import { getIsCaseDirty } from '../../../../store/subPages/selectors';
import useCaseIsReadOnly from '../../../../../../helpers/hooks/useCaseIsReadOnly/useCaseIsReadOnly';

const formatDueDiligenceText = (status: Nullable<DueDiligenceStatus>) => {
  if (!status || status === DueDiligenceStatus.AWAITING_ASSESSMENT) {
    return `Firm verification pending`;
  }
  if (status === DueDiligenceStatus.DECLINED) {
    return `Firm has failed due diligence`;
  }
  return ``;
};

const DATE_FORMAT = 'DD/MM/YYYY hh:mm a';

const Header: React.FC<Props> = ({
  caseDetails,
  onPresentButtonClick,
  onPepperButtonClick,
  onRefreshCaseClick,
  onSaveClick,
  banner,
  handleCloseBanner,
  isDuringSave,
}) => {
  const isCaseReadOnly = useCaseIsReadOnly();
  const history = useHistory();
  const shouldRefresh = useSelector(({ currentCase }: { currentCase: State }) => currentCase.refresh.shouldRefresh);
  const dueDiligenceStatus = useSelector(({ currentCase }: { currentCase: State }) => currentCase.dueDiligence.status);
  const isDirty = useSelector(getIsCaseDirty);

  const handleGoBackClick = () => {
    history.push(caseManagement.index);
  };

  const dueDiligenceClassNames = [styles.dueDiligenceStatus];

  if (!dueDiligenceStatus || dueDiligenceStatus === DueDiligenceStatus.AWAITING_ASSESSMENT) {
    dueDiligenceClassNames.push(styles.awaitingAssessment);
  }
  if (dueDiligenceStatus === DueDiligenceStatus.DECLINED) {
    dueDiligenceClassNames.push(styles.declined);
  }

  return (
    <div className={styles.header}>
      <div className={styles.caseInfo}>
        {banner.isVisible && (
          <div>
            <Banner handleBannerVisibility={handleCloseBanner} content={'Upload successful'} />
          </div>
        )}
        <div onClick={handleGoBackClick} className={styles.goBack}>
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.41 10.58L2.83 6L7.41 1.41L6 0L0 6L6 12L7.41 10.58Z" fill="#3A4451" />
          </svg>
        </div>
        <div>
          <p className={styles.applicants}>
            {caseDetails.case.applicants.map((applicant) => `${applicant.name} ${applicant.surname}`).join(' & ')}
          </p>
          <p className={styles.meta}>
            <span>{caseDetails.case.identifier}</span>
            <span className={styles.textDivider}>&#9679;</span>
            <span>Updated: {format(caseDetails.case.updatedAt).dateTime(DATE_FORMAT)}</span>
          </p>
        </div>
      </div>
      <div className={styles.toolbar}>
        {dueDiligenceStatus !== DueDiligenceStatus.APPROVED && (
          <div className={dueDiligenceClassNames.join(' ')}>
            <Icon type="warning" /> {formatDueDiligenceText(dueDiligenceStatus)}
          </div>
        )}
        {shouldRefresh && (
          <Button className={styles.refreshCaseButton} mode="ghost" onClick={onRefreshCaseClick}>
            Refresh case
          </Button>
        )}
        <Button mode="primary" onClick={onPepperButtonClick} disabled={isDirty}>
          Servicing
        </Button>
        <Separator separatorColor="#b3b3b3" marginLeft={10} marginRight={20} />
        <Button mode="ghost" onClick={onPresentButtonClick}>
          Present
        </Button>
        <Button className={styles.preofferButton} mode={'tertiary'} disabled>
          Preoffer
        </Button>
        <Button className={styles.preofferDropdownButton} mode={'tertiary'} disabled>
          <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0L5 5L10 0H0Z" fill="white" />
          </svg>
        </Button>
        {/* <Button className={styles.calculatorButton} mode={'ghost'} disabled={true}>
          <svg width="14" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 0h10a2 2 0 012 2v16a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm0 2v4h10V2H2zm0 6v2h2V8H2zm4 0v2h2V8H6zm4 0v2h2V8h-2zm-8 4v2h2v-2H2zm4 0v2h2v-2H6zm4 0v2h2v-2h-2zm-8 4v2h2v-2H2zm4 0v2h2v-2H6zm4 0v2h2v-2h-2z"
              fill="#3A4451"
            />
          </svg>
        </Button> */}
        <Button mode={'tertiary'} onClick={onSaveClick} disabled={isDuringSave || !isDirty || isCaseReadOnly}>
          {isDuringSave && 'Saving'}
          {!isDuringSave && 'Save'}
        </Button>
      </div>
    </div>
  );
};

export default Header;
